import React from "react";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import red from "@material-ui/core/colors/red";
import { dispatch, connect } from "../recontext/store";
import { api } from "../services/index";
import ButtonLogin from "../components/ButtonLogin";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  logo: {
    maxHeight: 26
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  logout: {
    color: red
  }
});

class Header extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleMenu = this.handleMenu.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
    this.handleClickProfile = this.handleClickProfile.bind(this);
    this.handleClickLogout = this.handleClickLogout.bind(this);
    this.state = {
      anchorEl: null
    };
  }

  handleMenu(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleCloseMenu() {
    this.setState({ anchorEl: null });
  }

  handleClickProfile() {
    this.setState({ anchorEl: null });
    dispatch("SHOW_UPDATE_PROFILE_DIALOG");
  }

  handleClickLogout() {
    this.setState({ anchorEl: null });
    api.logout();
  }

  render() {
    const { classes, user } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div className={classes.root}>
        <AppBar position="static" color="primary">
          <Toolbar>
            <Typography
              variant="title"
              color="inherit"
              className={classes.grow}
            >
              <a href="/">
                <img
                  src={require("../images/jxh_logo_white.png")}
                  className={classes.logo}
                  alt="JUNCTIONxHanoi"
                />
              </a>
            </Typography>
            {user ? (
              <div>
                <Button
                  aria-owns={open ? "menu-appbar" : null}
                  aria-haspopup="true"
                  onClick={this.handleMenu}
                  color="inherit"
                >
                  Hello {user.displayName}!
                  <Icon className={classes.rightIcon}>account_circle</Icon>
                </Button>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                  }}
                  open={open}
                  onClose={this.handleCloseMenu}
                >
                  <MenuItem onClick={this.handleClickProfile}>
                    Update Profile
                  </MenuItem>
                  <MenuItem onClick={this.handleClickLogout}>Logout</MenuItem>
                </Menu>
              </div>
            ) : (
              <ButtonLogin />
            )}
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(withStyles(styles)(Header));
